<ng-select
    [items]="pageSizes"
    bindLabel="name"
    placeholder="Select item"
    appendTo="body"
    (change)="onPageSizeSelected()"
    [(ngModel)]="pageSize"
>
</ng-select>
